export default "__VITE_ASSET__DTTpfvBO__"